// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__PuAK3","colCheckbox":"styles_colCheckbox__3Lykr"};